import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import {Links, Meta, Scripts, type LoaderFunctionArgs, type MetaFunction} from "react-router";
import {MantineProvider, createTheme} from "@mantine/core";
import {CsrfTokenApp} from "@digisthesia/remix-utils/csrf-token";
import {csrfTokenLoader, rootMiddlewares} from "@digisthesia/remix-utils/helpers.server";

//local
import "./styles.css";
import {HexploitTheme} from "./mantine-theme";
import {resolveLocaleFromRequest} from "./strings/global";

const theme = createTheme(HexploitTheme);

export function Layout({children}: {children: React.ReactNode}) {
  return (
    <html>
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        <Meta />
        <Links />
      </head>
      <body>
        <MantineProvider theme={theme}>{children}</MantineProvider>
        <Scripts />
      </body>
    </html>
  );
}

export const loader = (args: LoaderFunctionArgs) => ({
  ...csrfTokenLoader(args),
  locale: resolveLocaleFromRequest(args.request),
});
export const middleware = rootMiddlewares;
export const meta: MetaFunction = () => [{title: "Hexploit"}];
export default CsrfTokenApp;
